<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>
  
<div class="m-grid__item m-grid__item--fluid m-wrapper m-grid-responsive-lg" >
    <div class="m-content">
        <div class="row m-row">
            <div class="col-lg-12">
                <div class="m-portlet">

                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">
                                    SELFIE CAM PHOTOS
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                            <h4 *ngIf="this.photosToShow.length < 1"  class="m-portlet__head-text">
                                    No one has uploaded any selfies! (Yet!!)
                            </h4>
                        <div *ngIf="photosToShow" class="image-grid">
                            <div class="item" *ngFor="let photo of photosToShow">
                                <img [src]="photo.url" />
                                <div class="overlay">
                                    <a [href]="photo.url"><button class="overlay-btn"> Download </button></a>
                                    <button class="overlay-btn" (click)="deletePhoto(photo.photoId)"> Delete </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button (click)="return()" style="margin-bottom: 15px;" type="button" class="btn btn-info">Return</button>
    </div>   
</div>